import React from 'react';
import PropTypes from 'prop-types';
import { Pagination as MUIPagination, Box } from '@mui/material';

const styles = {
  root: {
    padding: '2px 0',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 0,
  },
};

class Pagination extends React.Component {
  handleChange = (event, page) => {
    // Convert from 1-based page number to 0-based index
    const index = page - 1;
    this.props.onChangeIndex(index);
  };

  handleKeyDown = (event) => {
    const { index = 0, dots } = this.props;
    
    if (event.key === 'ArrowLeft' && index > 0) {
      event.preventDefault();
      this.props.onChangeIndex(index - 1);
    } else if (event.key === 'ArrowRight' && index < dots - 1) {
      event.preventDefault();
      this.props.onChangeIndex(index + 1);
    }
  };

  render() {
    const { index = 0, dots } = this.props;
    
    // Don't render pagination if there are no dots
    if (!dots || dots <= 0) {
      return null;
    }

    // Ensure index is within valid range
    const safeIndex = Math.max(0, Math.min(index, dots - 1));
    const currentPage = safeIndex + 1;

    return (
      <Box 
        style={styles.root}
        onKeyDown={this.handleKeyDown}
        tabIndex={0}
        role="navigation"
        aria-label="Pagination navigation"
        data-tour="kiosk-pagination"
      >
        <MUIPagination
          count={dots}
          page={currentPage}
          onChange={this.handleChange}
          size="small"
          aria-label="Box extension pagination"
        />
      </Box>
    );
  }
}

Pagination.propTypes = {
  dots: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  onChangeIndex: PropTypes.func.isRequired,
};

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/common/MUIPagination.js